import React from "react";
import "./FamilyTree.css"; // Make sure to link the correct CSS file

const FamilyList = ({ FamilyListData = [] }) => {
    if (!FamilyListData.length) return <p>No family data available</p>;

    // Separate members by relations
    const self = FamilyListData.find(member => member.RelationName === "Self");
    const others = FamilyListData.filter(member => member.RelationName !== "Self");

    return (
        <div className="FamilyTree">
            {/* "You" (Self) at the top */}
            {self && (
                <div className="FamilyTreeBox Self">
                    <h1>You</h1>
                    <p>{self.MemberName}, {self.Age} yrs</p>
                    <span>{self.PolicyCount} policies</span>
                </div>
            )}

            {/* Family Members in Rows */}
            <div className="FamilyTreeRows">
                {others.map((item, index) => (
                    <div key={index} className={`FamilyTreeBox ${item.RelationName}`}>
                        <h1>{item.RelationName}</h1>
                        <p>{item.MemberName || "N/A"}, {item.Age} yrs</p>
                        <span>{item.PolicyCount} policies</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FamilyList;
